/* eslint-disable */
/**
 * The path of the `SettingsPage` to be consumed by a `<Router />`
 * @export
 */
export const SETTINGS_PAGE_PATH = `/settings`;

/**
 * Create a `href` that will resolve to `SettingsPage`
 * @export
 * @returns {string} The `SETTINGS_PAGE_PATH`
 */
export const createSettingsPageLink = () => SETTINGS_PAGE_PATH;

/**
 * Determine if the current page is the `SettingsPage`
 * @export
 * @param {RouterMatch<any>} match The `react-router-dom`'s `match` params
 * @returns {boolean} Whether or not the current page is `SettingsPage`
 */
export const isSettingsPage = (match) => match.path === SETTINGS_PAGE_PATH;
